export default __webpack_public_path__ + "assets/images/47b2b9a9c6a7d2db80221897e60528d4.png";